import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { App } from '@store/actions/app.actions';
import { CustomerActions } from '@store/actions/customer.actions';
import { CustomerService } from '@modules/shared/services/customer.service';

@Injectable()
export class CustomerEffects {
  private readonly actions$ = inject(Actions);
  private readonly customerService = inject(CustomerService);

  getCustomers$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.GET_CUSTOMERS, App.INITIALIZE),
    exhaustMap(() => this.customerService.getAll()
        .pipe(
          map(payload => ({type: CustomerActions.GET_CUSTOMERS_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.GET_CUSTOMERS_FAILED, error}))),
        )),
    ),
  );

  updateCustomer$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.UPDATE_CUSTOMER),
    exhaustMap(({payload}) => {
      return this.customerService.update(payload)
        .pipe(
          map(payload => ({type: CustomerActions.UPDATE_CUSTOMER_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.UPDATE_CUSTOMER_FAILED, error}))),
        );
    }),
    ),
  );

  createCustomer$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.CREATE_CUSTOMER),
    exhaustMap(({payload}) => this.customerService.create(payload)
        .pipe(
          map(payload => ({type: CustomerActions.CREATE_CUSTOMER_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.CREATE_CUSTOMER_FAILED, error}))),
        )),
    ),
  );

  deleteCustomer$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.DELETE_CUSTOMER),
    exhaustMap(({payload}) => this.customerService.delete(payload)
        .pipe(
          map(payload => ({type: CustomerActions.DELETE_CUSTOMER_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.DELETE_CUSTOMER_FAILED, error}))),
        )),
    ),
  );

  updatePassword$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.UPDATE_CUSTOMER_CREDENTIALS),
    exhaustMap(({payload}) => this.customerService.updatePassword(payload)
        .pipe(
          map(() => ({type: CustomerActions.UPDATE_CUSTOMER_CREDENTIALS_SUCCESS})),
          catchError(error => of(({type: CustomerActions.UPDATE_CUSTOMER_CREDENTIALS_FAILED, error}))),
        )),
    ),
  );

  fetchMe$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.GET_ME, App.INITIALIZE),
    exhaustMap(() => this.customerService.getProfile()
        .pipe(
          map(payload => ({type: CustomerActions.GET_ME_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.GET_ME_FAILED, error}))),
        )),
    ),
  );

  updateProfile$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerActions.UPDATE_PROFILE),
    exhaustMap(({payload}) => this.customerService.updateProfile(payload)
        .pipe(
          map(payload => ({type: CustomerActions.UPDATE_PROFILE_SUCCESS, payload})),
          catchError(error => of(({type: CustomerActions.UPDATE_PROFILE_FAILED, error}))),
        )),
    ),
  );
}
